import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faUtensils, faIceCream, faMugHot, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

// Íconos de referencia para cada tipo
const iconoRestaurante = <FontAwesomeIcon icon={faUtensils} style={{ color: "#d35400", marginRight: 8 }} />;
const iconoHeladeria = <FontAwesomeIcon icon={faIceCream} style={{ color: "#16a085", marginRight: 8 }} />;
const iconoCafe = <FontAwesomeIcon icon={faMugHot} style={{ color: "#8e44ad", marginRight: 8 }} />;

const restaurantes = [
  {
    nombre: "Red Wine – Buenos Momentos",
    link: "https://maps.app.goo.gl/bLyAj8ha45ehq8jE9",
    icono: iconoRestaurante,
    direccion: (
      <>
        Esquina Alvear y Roque Sáenz Peña – Paseo de la Estación.<br />
        3532 - 412000<br />
        <a href="https://redwine.com.ar/" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faGlobe} style={{ marginRight: 4 }} />
          Sitio web
        </a>
        <br />
        <a href="https://www.instagram.com/redwineoliva.ok/?igsh=OGhoczNobnQwNGhv" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "GNC Restaurante",
    link: "https://maps.app.goo.gl/ra3JWCdEDX6Gqw319",
    icono: iconoRestaurante,
    direccion: (
      <>
        Monseñor Gallardo Y Leandro N. Alem.<br />
        3532 - 15416095<br />
        <a href="https://gncoliva.ola.click/" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faGlobe} style={{ marginRight: 4 }} />
          Sitio web
        </a>
        <br />
        <a href="https://www.instagram.com/gncoliva/?igsh=MXF1dWtobHdncjZldg" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Lo de Gino´s",
    link: "https://maps.app.goo.gl/QSMcMTi2qLuD58ch8",
    icono: iconoRestaurante,
    direccion: (
      <>
        Av. Olmos 197.<br />
        0353 - 154178626<br />
        <a href="https://www.instagram.com/lodeginos/?igsh=cmtyMDViOGFrZmtj" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Sabor del Bueno",
    link: "https://maps.app.goo.gl/iFtn9GkL45kB3F1k9",
    icono: iconoRestaurante,
    direccion: (
      <>
        Mitre 65.<br />
        3532 - 413129<br />
        <a href="https://www.instagram.com/sabordelbueno1/?igsh=MXc4c2FzemR3cjluZw" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "La Sede 1921",
    link: "https://maps.app.goo.gl/nhNHDBD6KHcxjhSG9",
    icono: iconoRestaurante,
    direccion: (
      <>
        Av. Olmos 140.<br />
        0351 - 152121962<br />
        <a href="https://www.instagram.com/lasede1921/?igsh=eGVuYXI5d2FkMG42" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Delicias Norteñas",
    link: "https://maps.app.goo.gl/Bvmzv3bwvAQT5BfZ7",
    icono: iconoRestaurante,
    direccion: (
      <>
        Leandro N. Alem 1285.<br />
        03532 - 15471877<br />
        03532 - 410252<br />
        <a href="https://www.instagram.com/deliciasnortenas3/?igsh=NHppbXFxczNhZzRy" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Francesco Resto Bar",
    link: "https://maps.app.goo.gl/JgCDMXNnmi6WNpHK7",
    icono: iconoRestaurante,
    direccion: (
      <>
        Leandro N. Alem 130.<br />
        3532 - 448416<br />
        <a href="https://francescorestobar.online/" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faGlobe} style={{ marginRight: 4 }} />
          Sitio web
        </a>
        <br />
        <a href="https://www.instagram.com/francescorestobar/?igsh=MXFmdzR2MnkzcGxvaQ" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
];

const heladerias = [
  {
    nombre: "Grido Helados",
    link: "https://maps.app.goo.gl/dj46MvD15aJ1TVoK6",
    icono: iconoHeladeria,
    direccion: (
      <>
        Av. Olmos 111.<br />
        Fijo: 03532-412092. Celular: 3532-418010
      </>
    ),
  },
  {
    nombre: "Yo Helados",
    link: "https://maps.app.goo.gl/9dPavr3gYNXffq98A",
    icono: iconoHeladeria,
    direccion: (
      <>
        Roque Sáenz Peña 1.<br />
        3532-468383<br />
        <a href="https://www.instagram.com/layodeoliva/?igsh=dXNxcm90ZmNiemk1" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Dani Café - Cafetería y Heladería",
    link: "https://maps.app.goo.gl/MLHR1WEYF9uB9UZh7",
    icono: iconoHeladeria,
    direccion: (
      <>
        Esquina 9 de julio & Leandro N. Alem (Ruta N°9).<br />
        03532 - 15588022<br />
        <a href="https://www.instagram.com/dani_cafe85/?igsh=YWR3cWk0NDlrNzho" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "MAXIKIOSCO YO - Helados Sei Tu",
    link: "https://maps.app.goo.gl/QLRbh2nYprT7wXoc9",
    icono: iconoHeladeria,
    direccion: (
      <>
        Av. Olmos 173.<br />
        03532 - 15409429<br />
        <a href="https://www.instagram.com/maxikiosco_yo/?igsh=OXdyeW51c2Zjb3d3" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
];

const confiterias = [
  {
    nombre: "Mantino Bar - Café",
    link: "https://maps.app.goo.gl/Qi57j62S17En9XDH9",
    icono: iconoCafe,
    direccion: <>Esquina Pueyrredón y Roque Sáenz Peña.</>,
  },
  {
    nombre: "Lo de Gino´s",
    link: "https://maps.app.goo.gl/QSMcMTi2qLuD58ch8",
    icono: iconoCafe,
    direccion: (
      <>
        Av. Olmos 197.<br />
        0353 - 154178626<br />
        <a href="https://www.instagram.com/lodeginos/?igsh=cmtyMDViOGFrZmtj" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Yo Café",
    link: "https://maps.app.goo.gl/9dPavr3gYNXffq98A",
    icono: iconoCafe,
    direccion: (
      <>
        Roque Sáenz Peña 1.<br />
        3532 - 468383<br />
        <a href="https://www.instagram.com/layodeoliva/?igsh=dXNxcm90ZmNiemk1" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Shell Select",
    link: "https://maps.app.goo.gl/i4mMT7TSKq6u8iUB6",
    icono: iconoCafe,
    direccion: (
      <>
        Roque Sáenz Peña – Esquina Pueyrredón.<br />
        03532 - 420294<br />
        <a href="https://www.instagram.com/shell.oliva/?igsh=Z3dzcXpoenBnam0" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Punto de Encuentro",
    link: "https://maps.app.goo.gl/ouBhJCUsvHZR4zG96",
    icono: iconoCafe,
    direccion: (
      <>
        Av. Italia – Esquina La Rioja – Ruta 10.<br />
        03532 - 15401577<br />
        <a href="https://www.instagram.com/puntodeencuentro.oliva/?igsh=YWNpYmUzOXh1NjN3" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Padel CAVS",
    link: "https://maps.app.goo.gl/NMc69smNFDyCEQJY6",
    icono: iconoCafe,
    direccion: (
      <>
        Av. Olmos (Club Vélez Sarsfield).<br />
        03532 - 15400401<br />
        03532 - 15401054<br />
        <a href="https://www.instagram.com/padel_cavs/?igsh=b2R6MDR5OGh4c3cz" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Complejo de Padel Los Olmos",
    link: "https://maps.app.goo.gl/Rk5E7FebCy83hHnh7",
    icono: iconoCafe,
    direccion: (
      <>
        Juan Jose Paso 641.<br />
        03572 - 15503165<br />
        <a href="https://www.instagram.com/losolmos.oliva/?igsh=MWI0ZDRzdGNxYThicQ" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "La Cantina I.D.S.C",
    link: "https://maps.app.goo.gl/u3FKmXMaqWxkG99FA",
    icono: iconoCafe,
    direccion: (
      <>
        Roque Sáez Peña – Rutan Nacional 9 – Club I.D.S.C.<br />
        03532 - 15407017<br />
        <a href="https://www.instagram.com/lacantinadelidsc/?igsh=MWFpc2Vwc3Npd3Uzcg" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Dani Café - Cafetería y Heladería",
    link: "https://maps.app.goo.gl/MLHR1WEYF9uB9UZh7",
    icono: iconoCafe,
    direccion: (
      <>
        Esquina 9 de julio & Leandro N. Alem (Ruta N°9).<br />
        03532 - 15588022<br />
        <a href="https://www.instagram.com/dani_cafe85/?igsh=YWR3cWk0NDlrNzho" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "MAXIKIOSCO YO - Helados Sei Tu",
    link: "https://maps.app.goo.gl/QLRbh2nYprT7wXoc9",
    icono: iconoCafe,
    direccion: (
      <>
        Av. Olmos 173.<br />
        03532 - 15409429<br />
        <a href="https://www.instagram.com/maxikiosco_yo/?igsh=OXdyeW51c2Zjb3d3" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Bar la Camara",
    link: "#",
    icono: iconoCafe,
    direccion: (
      <>
        Colon.<br />
      </>
    ),
  },
  {
    nombre: "Grido Cafe",
    link: "https://maps.app.goo.gl/vKnt9XaRqvULi6H7A",
    icono: iconoCafe,
    direccion: (
      <>
        Av. Olmos 111.<br />
        03532 - 412092<br />
        03532 - 15418010
      </>
    ),
  },
  {
    nombre: "Shop YPF Santo Tomas",
    link: "https://maps.app.goo.gl/QeBbx57jkmoykF7Y6",
    icono: iconoCafe,
    direccion: (
      <>
        Leandro N. Alem 513.<br />
        <a href="https://www.instagram.com/ypf_santotomas/?igsh=azRxNDlmOWFjMnZp" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
  {
    nombre: "Sabores Fusión",
    link: "https://maps.app.goo.gl/SMdbBr2t4jgzrWNw6",
    icono: iconoCafe,
    direccion: (
      <>
        Güemes esquina Roque Sáenz Peña.<br />
        3543 - 535812<br />
        <a href="https://www.instagram.com/sabores.fusionok/?igsh=b3I5b28wenNkbmFn" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          Instagram
        </a>
      </>
    ),
  },
];

const Gastronomia = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-7">
        <h5>
          <FontAwesomeIcon icon={faUtensils} style={{ color: "#d35400", marginRight: 8 }} />
          Restaurantes
        </h5>
        <ul className="lista-referencias">
          {restaurantes.map((item, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              {item.icono}
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                {item.nombre}
              </a>
              <div className="ms-2 me-auto">{item.direccion}</div>
            </li>
          ))}
        </ul>
        <br />
        <h5>
          <FontAwesomeIcon icon={faIceCream} style={{ color: "#16a085", marginRight: 8 }} />
          Heladerías
        </h5>
        <ul className="lista-referencias">
          {heladerias.map((item, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              {item.icono}
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                {item.nombre}
              </a>
              <div className="ms-2 me-auto">{item.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-12 col-md-5">
        <h5>
          <FontAwesomeIcon icon={faMugHot} style={{ color: "#8e44ad", marginRight: 8 }} />
          Cafeterías
        </h5>
        <ul className="lista-referencias">
          {confiterias.map((item, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              {item.icono}
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                {item.nombre}
              </a>
              <div className="ms-2 me-auto">{item.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default Gastronomia;